// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"_3fCiZV","priceLabel":"sbV1Jt","image":"_3TMD5P","subTitle":"_3bdyRv","text":"pA0Pt-","hint":"FAUi1W","button":"_-6ckoN"};